module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatter"
  }, [_c('div', {
    staticClass: "title-frontMatter"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781250015945_toc01#toctitle2",
      "id": "title2"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Prologue")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-d"
  }, [_c('span', [_vm._v("15th May 1927")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Darling,")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("I wish you would tell me what is wrong. I cannot imagine what it is I have done to make you angry with me or what someone might have said to turn you against me so. If you refuse to meet me or speak to me when I ring you up how can I make it right again? I know that you love me as I love you and I am going to trust that whatever has happened to upset you it will pass and you will be my same old darling again soon.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-d"
  }, [_c('span', [_vm._v("Your Dearest xxx")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-d"
  }, [_c('span', [_vm._v("17th May 1927")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Dearest,")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("We have had more happy times this spring than some people get in their lifetimes and must count ourselves fortunate for them. I will treasure the memory of your love as long as I live. I am not what you thought I was and not what I myself thought I was either. I cannot explain and I must not see you again but you surely know that my heart is yours for ever.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-d"
  }, [_c('span', [_vm._v("Your Darling xxx")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13cf9f0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781250015945_fm01.vue
// module id = 72
// module chunks = 0